module.exports = __webpack_public_path__ + "tk.f61a89440a29a6e0173f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tk.svg
// module chunks = styles